import Axios from 'axios';
import React, { Component } from 'react';
import { speechService, speechTextService } from '../../utils/rxjs-sharing';
import { TRAINING_DATA_API, TRAINING_DATA_AUTH_TOKEN, SPEECH_TOKEN_API } from '../../utils/constant';

const SpeechSDK = require("microsoft-cognitiveservices-speech-sdk");
//Previous:
// const speechConfig = sdk.SpeechConfig.fromSubscription("32c9aabaa21c41678b3369b3ecfddd32", "centralindia");
// speechConfig.endpointId = "2f3ead9c-545e-444c-ac7d-01ec55e05390";
// speechConfig.speechRecognitionLanguage = "en-IN";
// speechConfig.enableDictation();
//Previous
let audioConfig;
let recognizer;

//Speech SDK Setter Function:
var speechConfig;
let tokenTimestamp = 0; // Track when the token was fetched
const TOKEN_EXPIRY_MS = 9 * 60 * 1000; // Refresh if token is older than 9 minutes (buffer before 10 min expiry)
// var SpeechSDK=window['SpeechSDK'];

// Fetch a fresh token from the backend
const fetchToken = async () => {
    const response = await Axios.get(SPEECH_TOKEN_API);
    const apiData = response.data.data || response.data;
    return apiData;
};

// Initialize or refresh speech config with a fresh token
const credentialConfig = async (forceRefresh = false) => {
    try {
        const now = Date.now();
        // Skip if token is still fresh and not forcing refresh
        if (speechConfig && !forceRefresh && (now - tokenTimestamp) < TOKEN_EXPIRY_MS) {
            return;
        }

        const { token, region, endpointId, language } = await fetchToken();
        const speechRegion = region || "centralindia";

        // Create new config or update existing token
        if (!speechConfig || forceRefresh) {
            speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, speechRegion);
            speechConfig.endpointId = endpointId || "1243e3d0-df4e-4a94-9787-8962e87aea6f";
            speechConfig.speechRecognitionLanguage = language || "en-IN";
            speechConfig.enableDictation();
        } else {
            // Just update the token on existing config
            speechConfig.authorizationToken = token;
        }

        tokenTimestamp = now;
        console.log("Speech token refreshed successfully");
    } catch (err) {
        console.error("Failed to fetch speech token from backend:", err);
    }
};
//Speech SDK Setter Function.

class MyHcSpeechRecognition extends Component {
    trainingData = {}

    constructor(props) {
        super(props)

        this.state = {
            speech: "",
            check: false,
            trainingDatafieldtypeSetter: {
                "chief-complaints": 0,
                "hpi": 1,
                "review-of-systems": 2
            },
            recognizerStatus: false,
            identifier: "",
        }
    }

    callTrainingDataApi(trainingData) {
        Axios({
            method: 'post',
            url: TRAINING_DATA_API,
            data: trainingData,
            headers: {
                Authorization: TRAINING_DATA_AUTH_TOKEN
            }
        });
    }

    componentDidMount() {
        credentialConfig();
        // Axios.post("https://api1.voiceai.myhealthcare.life/creds")
        //     .then(response => {
        //         return response.data
        //     })
        //     .then(config => {
        //         // console.log(config)
                credentialConfig()
            // })
            // .catch(err => {
            //     // console.log(err)
            //     credentialConfig([{ subscriptionkey: "" }])
            // })


        this.subscription = speechService.status().subscribe(data => {
            // console.log("Subscription Data:", data)
            if (data.identifier === null) {
                return;
            }
            if (data.state) {
                this.setState((prevState) => ({

                    speech: data.initialText,
                    identifier: data.identifier
                }), () => {
                    if (recognizer) {
                        this.stopListening()
                    }
                    this.startListening(data.identifier);
                    if (this.props !== undefined && Object.keys(this.props).length > 0) {
                        console.log(this.props)
                        this.trainingData = {
                            booking_id: this.props.booking_id,
                            source: 2,
                            doctor_id: this.props.doctor_id,
                            step: this.props.trainingDataStep[this.state.identifier] ? 1 : 0,
                            input_text: this.props[this.state.identifier] ? this.props[this.state.identifier] : "",
                            field_type: this.state.trainingDatafieldtypeSetter[this.state.identifier]
                        }
                        if (this.trainingData["input_text"].length > 0) {
                            //call API
                            this.callTrainingDataApi(this.trainingData)
                            // console.log("Start Listening:", trainingData)
                        }
                    }
                });

            }
            if (!data.state) {
                if (recognizer && this.state.recognizerStatus) {
                    // console.log(recognizer)    
                    this.stopListening();
                    //Mic stops and data.initialText has required value of step 0
                    //Call API
                    //create object and call API
                    if (this.props !== undefined && Object.keys(this.props).length > 0) {
                        this.trainingData = {
                            booking_id: this.props.booking_id,
                            source: 2,
                            doctor_id: this.props.doctor_id,
                            step: 0,
                            input_text: (data.initialText === undefined || data.initialText === null) ? this.props[data.identifier] === undefined ? "" : this.props[data.identifier] : data.initialText,
                            field_type: this.state.trainingDatafieldtypeSetter[data.identifier]
                        }
                        this.callTrainingDataApi(this.trainingData)
                        // console.log("Stop Listening:", trainingData)
                    }
                }

            }
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    startListening(identifier) {
        this.setState({
            recognizerStatus: true
        }, async () => {
            // Always ensure we have a fresh token before starting
            // This handles the case where user was idle for 10+ minutes
            await credentialConfig();

            if (!speechConfig) {
                console.error("Speech config not available — cannot start listening");
                return;
            }
            // console.log(recognizer)
            // if (recognizer) {
            //     // console.log("In stop recognition")
            //     Promise.resolve(recognizer.stopContinuousRecognitionAsync())
            //     setTimeout(() => {
            //         recognizer.startContinuousRecognitionAsync()
            //     }, 100)
            // } else {
                // console.log("In else start recognition")
                audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
                recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
                await Promise.resolve(recognizer.startContinuousRecognitionAsync());
            // }

            function sentenceCase(inputString) {
                //regex operation
                inputString = inputString.replace(/centimeter(s?)|centimetre(s?)|CM/gi, "cm")
                    .replace(/( ?)(degree|degrees)?( ?)(celsius)/gi, '°C')
                    .replace(/( ?)(degree|degrees)?( ?)(fahrenheit)/gi, '°F')
                    .replace(/\ {2,}/g, ' ')
                    .replace(/\w+(?=\n)/g, inputString.match(/\w+(?=\n)/g)+ ".")
                    
                return inputString
            }

            recognizer.recognizing = (s, e) => {
                var temp = e.result.text + " "
                temp= sentenceCase(temp)
                if (identifier !== 'drop_list') {
                    let speechTxt = this.state.speech !== undefined ? this.state.speech : '';
                    speechTextService.init({ text: speechTxt + temp});
                }
                //  else {
                //     speechTextService.init({ text: temp});
                // }
            }
            recognizer.recognized = (s, e) => {
                if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech && e.result.text !== '') {
                    // var temp = e.result.text + " ";
                    var temp = /\n/g.test(e.result.text) ? e.result.text : e.result.text + " "
                    temp = sentenceCase(temp);
                    this.setState({
                        speech: this.state.speech + temp,
                    }, () => {
                        if(identifier === 'drop_list'){
                            speechTextService.init({ text: temp });
                        }else{
                            speechTextService.init({ text: this.state.speech });
                        } 
                    })
                }
                else if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
                    console.log("NOMATCH: Speech could not be recognized.");
                }
            }
            recognizer.canceled = (s, e) => {
                console.log(`CANCELED: Reason=${e.reason}`);

                if (e.reason === SpeechSDK.CancellationReason.Error) {
                    console.log(`"CANCELED: ErrorCode=${e.errorCode}`);
                    console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`);
                    console.log("CANCELED: Did you update the subscription info?");
                    // If auth/connection error, refresh token and retry once
                    if (e.errorCode === SpeechSDK.CancellationErrorCode.ConnectionFailure ||
                        e.errorCode === SpeechSDK.CancellationErrorCode.AuthenticationFailure ||
                        (e.errorDetails && e.errorDetails.includes('401'))) {
                        console.log("Token may have expired — refreshing and retrying...");
                        recognizer.stopContinuousRecognitionAsync();
                        credentialConfig(true).then(() => {
                            if (speechConfig && this.state.recognizerStatus) {
                                audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
                                recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
                                recognizer.startContinuousRecognitionAsync();
                            }
                        });
                        return;
                    }
                }

                recognizer.stopContinuousRecognitionAsync();
            }
            recognizer.sessionStopped = (s, e) => {
                console.log("\n Session stopped event.");
                recognizer.stopContinuousRecognitionAsync();
            }
        })
    }

    async stopListening() {
        recognizer.stopContinuousRecognitionAsync()
        this.setState({
            // speech: "",
            recognizerStatus: false,
        });
    }

    render() {
        return (
            <></>
        )
    }

}

export default MyHcSpeechRecognition;
